import { render, staticRenderFns } from "./CreativeTestDay.vue?vue&type=template&id=a36558e2&scoped=true"
import script from "./CreativeTestDay.vue?vue&type=script&lang=js"
export * from "./CreativeTestDay.vue?vue&type=script&lang=js"
import style0 from "./CreativeTestDay.vue?vue&type=style&index=0&id=a36558e2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a36558e2",
  null
  
)

export default component.exports